module.exports = __webpack_public_path__ + "static/CircularPro-BoldItalic.26c6def8.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BoldItalic.ttf
// module id = 721
// module chunks = 168707334958949